import React, { createContext, useContext, useState } from 'react';

const LicenseBannerContext = createContext();

export const useLicenseBanner = () => {
  const context = useContext(LicenseBannerContext);
  if (!context) {
    return { isVisible: false, bannerHeight: 0 };
  }
  return context;
};

export const LicenseBannerProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [bannerHeight, setBannerHeight] = useState(0);

  return (
    <LicenseBannerContext.Provider value={{ isVisible, setIsVisible, bannerHeight, setBannerHeight }}>
      {children}
    </LicenseBannerContext.Provider>
  );
};













